import { Audio, Buttons, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import WordSelector from '../game/WordSelector';
import gameData from '../gameData';
import PopupDialog from '../ui/popupDialog';
import IntroScreen, { horizontalScreenTransisition } from './IntroScreen';
import LevelScreen from './LevelScreen';
import ABCyaLib from '@abcya/abcya_lib';
import UIAssetKeys from '../UIAssetKeys';

export default class GameScreen extends Phaser.Scene {
  static get KEY() { return 'GameScreen'; }

  static get WIN_COMPLETE() { return 'WIN_COMPLETE'; }

  init() {
    if (gameData.currentLevel === null) {
      // set the current level if it's null, allows for going straight to this scene for testing
      gameData.currentLevel = gameData.levels.birthday_bash;
    }
  }

  create() {
    this.totalCorrect = 0;
    this.currentWordIndex = null;
    const width = this.scale.width;
    const height = this.scale.height;

    const image = gameData.currentLevel.levelImage;
    this.clickZone = Images.addImage(0, 0, image, this, gameData.currentLevel.imageAtlas).setOrigin(0);

    this.wordSelector = new WordSelector(this, gameData.currentLevel);
    this.add.existing(this.wordSelector);
    this.wordSelector.setPosition(0, height - this.wordSelector.getBounds().height);

    this.hitDetection = [];

    // HITBOX DEBUG
    // this.graph = this.add.graphics();
    // this.graph.fillStyle(0x44ee00, .5);

    gameData.currentLevel.wordPositions.forEach((wordPositions) => {
      const hitDetections = [];
      this.hitDetection.push(hitDetections);
      wordPositions.forEach((position) => {
        const currentCell = position;
        hitDetections.push(new Phaser.Geom.Rectangle(currentCell[0], currentCell[1], currentCell[2], currentCell[3]));

        // HITBOX DEBUG
        // this.graph.fillRectShape(hitDetections[hitDetections.length - 1]);
      });
    });

    this.clickZone.setInteractive();
    this.clickZone.on('pointerdown', (pointer, downX, downY) => {this.handleClickOnImage(downX, downY);});

    this.wordSelector.on(WordSelector.WORD_SELECTED, arg => this.handleWordSelected(arg));

    Tweens.addTween(this.wordSelector, 1500, { y: { start: this.wordSelector.y + 350, to: this.wordSelector.y } }, Phaser.Math.Easing.Bounce.Out);

    this.textLabelBack = this.add.graphics();
    const text = gameData.currentLevel.name;
    const textLabel = this.add.text(width / 2, 5, text, { fontFamily: 'carton_sixregular', color: '#fff', fontSize: '20pt', align: 'center' }).setOrigin(.5, 0);
    const padding = 20;

    const gameConfig = ABCyaLib.Environment.instance.gameConfig;
    if (gameConfig.levels === null) {
      this.closeButton = Buttons.addButton(width - 30, 30, 'close_button', 'close_button', null, () => this.closeClicked(), this);

      const textLabelBounds = textLabel.getBounds();
      this.textLabelBack.fillStyle(0x000000, 0.5);
      this.textLabelBack.fillRoundedRect(textLabelBounds.left - padding, 0 - padding, textLabelBounds.width + 2 * padding, textLabelBounds.height + 35,10);
    }
    else {
      const levelLabel = this.add.text(width / 2 - 6, 8, `Level ${gameData.variantLevelIndex + 1}/${gameConfig.levels.length}:`, { fontFamily: 'carton_sixregular', color: '#fff', fontSize: '18pt', align: 'right' }).setOrigin(1, 0);
      textLabel.setOrigin(0);
      textLabel.x += 6;
      textLabel.style.align = 'left';
      const textLabelBounds = textLabel.getBounds();
      const levelLabelBounds = levelLabel.getBounds();
      this.textLabelBack.fillStyle(0x000000, 0.5);
      this.textLabelBack.fillRoundedRect(levelLabelBounds.left - padding, -padding,levelLabelBounds.width + textLabelBounds.width + 2 * padding, textLabelBounds.height + 35,10);
    }

    this.speakerButton = Images.addImage(35, 35, 'speaker_on_button', this);
    if (!gameData.MUSIC_ON) {
      this.speakerButton.setFrame('speaker_off_button');
    }
    this.speakerButton.scaleX = 0.7;
    this.speakerButton.scaleY = 0.7;
    this.speakerButton.setInteractive();
    this.speakerButton.on('pointerdown', () => {
      if (gameData.MUSIC_ON) {
        this.speakerButton.setFrame('speaker_off_button');
        gameData.MUSIC_ON = false;
        this.sound.stopAll();
      }
      else if (!gameData.MUSIC_ON) {
        this.speakerButton.setFrame('speaker_on_button');
        gameData.MUSIC_ON = true;
        Audio.playOneShot('jingle', this, 1, true);
      }
    });

    if (!gameData.INSTRUCTIONS_SEEN) {
      gameData.INSTRUCTIONS_SEEN = true;
      this.showHint();
    }
  }

  closeClicked() {
    Audio.playOneShot('click', this);
    this.stopDialog = new PopupDialog(this, 'HomeBtnPopup');
    this.add.existing(this.stopDialog);

    this.stopDialog.yesButton.on('pointerdown', () => {
      this.stopDialog.noButton.removeInteractive();
      this.stopDialog.yesButton.removeInteractive();
      Audio.playOneShot('click', this);
      horizontalScreenTransisition(this, LevelScreen.KEY, false);
    });

    this.stopDialog.noButton.on('pointerdown', () => {
      Audio.playOneShot('click', this);
      this.stopDialog.destroy();
    });

    this.stopDialog.x = this.scale.width / 2;
    this.stopDialog.y = this.scale.height / 2;
  }

  showHint() {

    this.hintDialog = new PopupDialog(this, 'InstructionsPopup');
    this.add.existing(this.hintDialog);

    this.hintDialog.okButton.on('pointerdown', () => {
      Audio.playOneShot('click', this);
      this.hintDialog.destroy();
    });

    this.hintDialog.x = this.scale.width / 2;
    this.hintDialog.y = this.scale.height / 2;
  }

  handleWordSelected(wordRect) {
    this.currentWordIndex = wordRect.number;
  }

  handleClickOnImage(downX, downY) {
    let hitStatus = false;
    this.clickZone.disableInteractive();
    if (this.currentWordIndex !== null) {
      for (const rects in this.hitDetection[this.currentWordIndex]) {
        const hitTestRect = this.hitDetection[this.currentWordIndex][rects];

        if (hitTestRect.contains(downX, downY))hitStatus = true;
      }

      if (hitStatus) {
        Audio.playOneShot('correct', this);

        this.wordSelector.disableWord(this.currentWordIndex);
        this.totalCorrect++;
        this.currentWordIndex = null;
        if (this.totalCorrect === gameData.currentLevel.words.length) {
          this.closeButton?.disableInteractive();
          gameData.currentLevel.isCompleted = true;

          let levelCompleteCheck = 0;
          let totalLevels = 0;
          for (const key in gameData.levels) {
            totalLevels++;
            if (gameData.levels[key].isCompleted) levelCompleteCheck++;
          }

          if (ABCyaLib.Environment.instance.gameConfig.levels !== null) {
            levelCompleteCheck = 0;
            totalLevels = ABCyaLib.Environment.instance.gameConfig.levels.length;

            // we're in a variant, need to check if all of the specific levels are complete, if so, show the level complete popup
            ABCyaLib.Environment.instance.gameConfig.levels.forEach((level) => {
              if (gameData.levels[level].isCompleted) levelCompleteCheck++;
            });
          }

          if (levelCompleteCheck === totalLevels && !gameData.WIN_SEEN) {
            const back = this.add.rectangle(this.scale.width / 2, this.scale.height / 2, this.scale.width, this.scale.height, 0x000000, 1).setAlpha(.001)
              .setInteractive();

            Tweens.addTween(back, 800, { alpha: .5 });

            const array = ['yay', 'awesome', 'great_job'];

            const spriteName = Phaser.Math.Between(0, 2);
            const text = ABCyaLib.Environment.instance.gameConfig.levels === null ? 'You finished all the levels!' : 'You completed the game!';
            const botText = this.add.text(this.scale.width / 2, this.scale.height / 2, text, { fontFamily: 'carton_sixregular', color: '#fff', fontSize: '50pt' }).setOrigin(.5, 0);
            const celebrate = Images.addImage(this.scale.width / 2, 0, array[spriteName], this);
            celebrate.y = botText.y - 40 - celebrate.height / 2;

            const btnImage = ABCyaLib.Environment.instance.gameConfig.levels === null ? 'BTN_home' : UIAssetKeys._variants_Btn_PlayAgain;
            const homeButton = Images.addImage(botText.x, botText.getBottomCenter().y + 62, btnImage, this);
            homeButton.setInteractive();
            homeButton.setOrigin(.5, 0);
            homeButton.setScale(1, 0);
            botText.setScale(1, 0);

            Tweens.addTween(celebrate, 750, { scaleY: { start: 0, to: 1 } }, Phaser.Math.Easing.Linear, () => {

              Tweens.addTween(celebrate, 750, { scaleY: -1, yoyo: true }, Phaser.Math.Easing.Linear, () => {
                Tweens.addTween(botText, 750, { scale: 1 }, Phaser.Math.Easing.Bounce.Out,() => {
                  Tweens.addTween(homeButton, 750, { scale: 1 }, Phaser.Math.Easing.Bounce.Out,() => {

                    homeButton.once('pointerdown', () => {this.events.emit(GameScreen.WIN_COMPLETE);});

                  });
                });
              });
            });

            this.events.once(GameScreen.WIN_COMPLETE, () => {
              gameData.WIN_SEEN = true;

              horizontalScreenTransisition(this.scene.get(GameScreen.KEY), IntroScreen.KEY, false);
            });
          }
          else {
            playWinAnimation(this);

            this.events.once(GameScreen.WIN_COMPLETE, () => {
              if (ABCyaLib.Environment.instance.gameConfig.levels === null) {
                horizontalScreenTransisition(this.scene.get(GameScreen.KEY), LevelScreen.KEY, false);
              }
              else {
                // go to the next level
                gameData.variantLevelIndex++;
                gameData.currentLevel = gameData.levels[ABCyaLib.Environment.instance.gameConfig.levels[gameData.variantLevelIndex]];
                this.scene.start();
              }
            });
          }
        }
        else {
          this.clickZone.setInteractive();
        }
      }
      else {
        Audio.playOneShot('error', this);
        this.clickZone.setInteractive();
      }
    }
    else {
      this.clickZone.setInteractive();
    }
  }
}

export function playWinAnimation(scene) {

  const array = ['yay', 'awesome', 'great_job'];

  const spriteName = Phaser.Math.Between(0, 2);
  const celebrate = Images.addImage(scene.scale.width / 2, scene.scale.height / 2, array[spriteName], scene);

  Tweens.addTween(celebrate, 750, { scaleY: { start: 0, to: 1 } }, Phaser.Math.Easing.Linear, () => {
    Tweens.addTween(celebrate, 750, { scaleY: -1, yoyo: true, completeDelay: 1400 }, Phaser.Math.Easing.Linear, () => {
      celebrate.destroy();
      scene.events.emit(GameScreen.WIN_COMPLETE);
    });
  });

  return celebrate;
}

